/* eslint-disable*/
import VueStoreService from './VueStoreService';
const ExternalMovement = {
    async getMovements(url,store){
        var resp = await VueStoreService.get("api/external-movement"+url, store)
        return resp;
    },
    async saveMovements(data,store){
        var resp = await VueStoreService.post("api/external-movement",data,store)
        return resp;
    },
    async getMovExternal(mov_id,store){
        var resp = await VueStoreService.get( "api/external-movement/"+mov_id,store)
        return resp;
    },
    async updateProcess(mov_id,data,store){
        var resp = await VueStoreService.patch("api/external-movement/updateProcess/"+mov_id,data,store)
        return resp;
    },
    async updateMov(mov_id,data,store){
        var resp = await VueStoreService.patch("api/external-movement/"+mov_id,data,store)
        return resp;
    },
}

export default ExternalMovement;